<button class="btn btn-primary mb-2" (click)="print()">Imprimer</button>
<button
  class="btn btn-secondary mb-2 ms-3 rounded-2"
  (click)="downloadTextFile()"
>
  Télécharger fichier Cnam
</button>
<div class="table-responsive" #printSection>
  <table
    border="0"
    cellpadding="0"
    cellspacing="0"
    id="sheet0"
    class="sheet0 gridlines"
  >
    <!-- Your table content remains the same -->
    <thead>
      <colgroup>
        <col style="width: 15%" />
        <!-- Date des soins -->
        <col style="width: 10%" />
        <!-- I.U de l'assuré -->
        <col style="width: 15%" />
        <!-- Prénom -->
        <col style="width: 10%" />
        <!-- Qualité -->
        <col style="width: 10%" />
        <!-- Code APCI -->
        <col style="width: 10%" />
        <!-- Code Acte -->
        <col style="width: 10%" />
        <!-- Cotation -->
        <col style="width: 10%" />
        <!-- Montant Total -->
        <col style="width: 10%" />
        <!-- Ticket Modérateur -->
        <col style="width: 10%" />
        <!-- Montant CNAM -->
        <col style="width: 10%" />
        <!-- Code Médecin -->
        <col style="width: 10%" />
        <!-- Code Médecin -->
      </colgroup>
      <tr class="row0">
        <td class="column0 style7 s style7" colspan="11">
          NOTE D'HONORAIRE DES CONSULTATIONS ET DES ACTES AMBULATOIRES EFFECTUES
          PAR MEDECIN CONVENTIONNE DANS LE CADRE DU TIERS PAYANT
        </td>
      </tr>
      <tr class="row0 doctor-info">
        <td class="column0 style7 s style7" colspan="11">
          <div class="d-flex justify-content-start gap-3 p-3">
            <div class="d-flex flex-row gap-2">
              <div>
                <strong>Médecin : </strong>
<span>{{ getDisplayName(doctor) }}</span>              </div>

            </div>
            <div class="d-flex flex-row gap-2">
              <strong>code Conventionnel : </strong>
              <span>{{ doctor.cnam }}</span>
            </div>
            <div *ngIf="doctor.matriculeFiscal" class="d-flex flex-row gap-2">
              <strong>matriculeFiscal:</strong>
              <span>{{ doctor.matriculeFiscal }}</span>
            </div>
            <div *ngIf="startDate" class="d-flex flex-row gap-2">
              Debut:
              <span>{{ startDate | date : "dd/MM/yyyy" }}</span>
            </div>
            <div *ngIf="finDate" class="d-flex flex-row gap-2">
              Fin:
              <span>{{ finDate | date : "dd/MM/yyyy" }}</span>
          </div>
          </div>
        </td>
      </tr>
      <tr class="row1">
        <td class="column0 style2 s style2" rowspan="2">Date des soins</td>
        <td class="column1 style2 s style2" rowspan="2">I.U de l'assuré</td>
        <td class="column2 style2 s style2" colspan="3">
          Identité du Bénificiaire
        </td>
        <td class="column5 style2 s style2" colspan="2">Actes Effectués</td>
        <td class="column7 style3 s style3" rowspan="2">Montant Total</td>
        <td class="column8 style3 s style3" rowspan="2">
          Ticket Modérateur Percu par l'assuré
        </td>
        <td class="column9 style2 s style2" rowspan="2">
          Montant à la charge de la CNAM
        </td>
        <td class="column10 style2 s style2" rowspan="2">
          Code Conventionnel du Médecin traitant **
        </td>
        <th rowspan="2" class="no-print">Action</th>
      </tr>
      <tr class="row2">
        <td class="column2 style1 s">Prénom</td>
        <td class="column3 style1 s">Qualité</td>
        <td class="column4 style1 s">Code APCI</td>
        <td class="column5 style1 s">Code Acte</td>
        <td class="column6 style1 s">Cotation</td>
      </tr>
    </thead>
    <tbody>
  <tr
  class="row3"
  *ngFor="let bord of paginatedData; let i = index"
  [ngClass]="{
    'class-row-disabled': bord.isDisabled,
    'class-row': !bord.isDisabled,
    'row-controle': bord.isControle
  }"
  [title]="bord.isControle ? 'Consultation de contrôle (J+' + bord.joursDepuis + ') — non facturable' : ''"
>
   <td class="column0 style1 text-center">
  {{ bord.date | date : "dd/MM/yyyy" }}
  <span *ngIf="bord.isControle" class="badge-controle no-print">
    Contrôle J+{{ bord.joursDepuis }}
  </span>
</td>
        <td class="column1 style1 text-center">{{ bord.cnamCode }}</td>
        <td class="column2 style1 text-center">
          {{ bord.firstName }} {{ bord.lastName }}
        </td>
        <td class="column3 style1 text-center">
          {{
            bord.cnamAssociation == 0
              ? "Assuré"
              : bord.cnamAssociation == 1
              ? "Conjoint"
              : bord.cnamAssociation == 2
              ? "Mére"
              : bord.cnamAssociation == 3
              ? "Pére"
              : "Enfant"
          }}
        </td>
        <td class="column4 style1 text-center">{{ bord.apcis }}</td>
        <td class="column5 style1 text-center">{{ bord.motif }}</td>
        <td class="column6 style1 text-center">{{ bord.descActe }}</td>
        <td class="column7 style1 text-center">
          {{ bord.regularConsultationAmountCNAM }}
        </td>
        <td class="column8 style1 text-center">
          {{ bord.apcis !== "" ? 0 : bord.regularConsultationAmountCNAMTP }} 
        </td>
        <td class="column9 style1 text-center">
          {{
            bord.apcis !== ""
              ? bord.regularConsultationAmountCNAM
              : bord.regularConsultationAmountCNAM -
                bord.regularConsultationAmountCNAMTP
          }}
        </td>
<td class="column10 style1 text-center">
  {{ (doctor.speciality.label !== 'Généraliste' && doctor.speciality.label !== 'Médecin de famille')
      ? bord.familyDoctorMatricule
      : doctor.cnam }}
</td>        <td class="column11 style1 text-center no-print">
        <input
  type="checkbox"
  [(ngModel)]="bord.isDisabled"
 
  (change)="updateVisibleRows()"
/>
        </td>
      </tr>

      <tr class="row13">
        <td class="column0 style4 s style4" colspan="9">TOTAL A REPORTER</td>
        <td class="column9 style2 null style2" colspan="2"></td>
      </tr>
      <tr class="row14">
        <td class="column0 style4 s style4" colspan="9">TOTAL A PAYER</td>
        <td class="column9 style2 null style2" colspan="2">{{ total }}</td>
      </tr>
      <tr class="row15">
        <td class="column0 style6 s style6" colspan="11">
         <strong>Arreter le present en toute lettres :</strong> 
{{ total | montantLettre }}
        </td>
      </tr>
      <tr class="row16">
        <td class="column0 style5 s style5" colspan="11">
          ………………………………………………..………………………………………………..………………………………………………..………………………………………………..………………………………………………..
        </td>
      </tr>
    </tbody>
  </table>
  <div class="pagination no-print">
    <button (click)="prevPage()" [disabled]="currentPage === 1">
      Précédent
    </button>

    <ng-container
      *ngFor="let page of [].constructor(totalPages); let i = index"
    >
      <button (click)="goToPage(i + 1)" [class.active]="currentPage === i + 1">
        {{ i + 1 }}
      </button>
    </ng-container>

    <button (click)="nextPage()" [disabled]="currentPage === totalPages">
      Suivant
    </button>
  </div>
</div>
